import { DOCUMENT, inject, Service } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { sendMessageToDevice } from '@ideals/utils';

const THEME_DARK_KEY = 'ideals-theme-dark';
const THEME_MESSAGE_DELAY = 350;
const DARK_BACKGROUND = '#1F2129';
const LIGHT_BACKGROUND = '#FFFFFF';

@Service()
export class ColorSchemeService {
  readonly #cookieService = inject(CookieService);
  readonly #document = inject(DOCUMENT);

  readonly isDarkMode = this.#cookieService.check(THEME_DARK_KEY)
    ? JSON.parse(this.#cookieService.get(THEME_DARK_KEY)) as boolean
    : window.matchMedia('(prefers-color-scheme: dark)').matches;

  initialize(): void {
    this.#document.body.classList.add(this.isDarkMode ? 'dark' : 'light');

    setTimeout(() => {
      sendMessageToDevice('changeThemeBackground', this.isDarkMode ? DARK_BACKGROUND : LIGHT_BACKGROUND);
    }, THEME_MESSAGE_DELAY);
  }
}
